import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-blog-carousel]',
};

class BlogCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);
      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Navigation, Scrollbar],
      lazy: true,
      lazyPreloadPrevNext: 2,
      slidesPerView: 1.2,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.slider-scrollbar',
        draggable: true,
        hide: false,
        snapOnRelease: false,
        dragSize: 40,
      },
      breakpoints: {
        640: {
          slidesPerView: 2.2,
          spaceBetween: 20,
          scrollbar: {
            dragSize: 140,
          },
        },
        744: {
          slidesPerView: 2.2,
          spaceBetween: 28,
          scrollbar: {
            dragSize: 140,
          },
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 28,
          scrollbar: {
            dragSize: 140,
          },
        },
        1665: {
          slidesPerView: 3,
          spaceBetween: 30,
          scrollbar: {
            dragSize: 140,
          },
        }
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.carousel.update();
    });
  }
}

customElements.define('blog-carousel', BlogCarousel);
